import React from 'react';
import Title from '../title/title';
import OptimizedImage from '../optimizedImage/optimizedImage';
import './gallery.scss';

// Import images
import image1 from '../../assets/optimized/patiopurpura/IMG-20250603-WA0003~3.jpg';
import image2 from '../../assets/optimized/patiopurpura/IMG-20250603-WA0005~2.jpg';
import image3 from '../../assets/optimized/patiopurpura/IMG-20250603-WA0006~2.jpg';
import image4 from '../../assets/optimized/patiopurpura/PXL_20250612_035823824~2.jpg';
import image5 from '../../assets/optimized/patiopurpura/PXL_20250612_035848897.jpg';
import image6 from '../../assets/optimized/pan-frutos-rojos.jpg';

const images = [image1, image2, image3, image4, image5, image6];

const Gallery = () => {
  return (
    <section className="gallery-section">
      <Title myTitle="Galería" className="gallery-title" />
      <div className="gallery-grid">
        {images.map((image, index) => (
          <div key={index} className="gallery-item">
            <OptimizedImage 
              src={image} 
              alt={`Patio Purpura bread ${index + 1}`}
              className="gallery-image"
              sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 33vw"
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Gallery;